import React from "react";
import "@styles/components/ui/PageLoader.scss";
import { Box, CircularProgress, Typography } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { transform } from "typescript";

const PageLoader = ({ visible = true }) => {
  return (
    <Box className="page-loader-container">
      <AnimatePresence>
        {visible && (
          <motion.div
            initial={{ opacity: 1 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{
              opacity: {
                delay: 1,
                duration: 0.25,
              },
            }}
            style={{
              position: "fixed",
              inset: 0,
              background: "#000",
              zIndex: 99999,
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Box className="icon-container">
              <motion.img
                className="logo-rotate"
                src={`${process.env.PUBLIC_URL}/assets/images/global/logo.png`}
                alt="logo"
                initial={{ scale: 0, opacity: 0, rotate: 0 }} // 初始：細＋透明
                animate={{
                  scale: 1,
                  opacity: 1,
                  rotate: 360,
                }}
                transition={{
                  duration: 0.5, // 入場時間
                  rotate: {
                    // repeat: Infinity, // 無限 loop
                    // repeatType: "loop",
                    // ease: "linear",
                    // duration: 2, // 幾耐轉一圈
                  },
                }}
              />
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default PageLoader;
